export default __webpack_public_path__ + "static/frankie-a36344d7b3ac6ce044b80be0a6c13d7b.svg";